const state = {
    governingBodies: null
};

// getters
const getters = {
    getGoverningBodies: (state) => {
        return state.governingBodies;
    },
};

// mutations
const mutations = {
    storeGoverningBodies(state, governingBodies) {
        state.governingBodies = governingBodies;
    },
};

// actions
const actions = {
    storeGoverningBodies: ({commit}, governingBodies) => {
        commit('storeGoverningBodies', governingBodies);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}